/* Pet Nugget theme — nugget.js
 * Long-form article template: chapter menu built from headings, sticky chapter nav with
 * active state, reading-progress bar, and automatic placement of the product / newsletter
 * blocks inside the post body, plus hand-placed [[shortcode]] blocks such as the dog age calculator.
 * No dependencies. Loaded with defer from sections/nugget-article.liquid. */
(function () {
  'use strict';
  function init() {
  var root = document.querySelector('[data-nugget]');
  if (!root || root.hasAttribute('data-nugget-ready')) return;
  root.setAttribute('data-nugget-ready', '');

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var body = $('[data-nugget-body]', root);
  if (!body) return;

  var cfg = {};
  try { cfg = JSON.parse($('[data-nugget-config]', root).textContent) || {}; } catch (e) {}
  cfg.productAfter = parseInt(cfg.productAfter, 10) || 2;
  cfg.newsletterAfter = parseInt(cfg.newsletterAfter, 10) || 4;
  cfg.minHeadings = parseInt(cfg.minHeadings, 10) || 2;

  var headerEl = $('.site-header');
  function headerHeight() { return headerEl ? headerEl.getBoundingClientRect().height : 72; }

  /* ---------------- 1. Headings → ids ---------------- */
  var usedIds = {};
  $$('[id]').forEach(function (el) { usedIds[el.id] = true; });
  function slugify(text) {
    var s = String(text || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return s || 'section';
  }
  var selector = cfg.includeH3 ? 'h2, h3' : 'h2';
  var headings = $$(selector, body).filter(function (h) { return (h.textContent || '').trim().length > 0; });
  var chapters = []; // H2s only — these drive placement and the chapter bar
  var chapterOf = {}; // heading id → label of the H2 it belongs to
  var lastH2 = null;
  headings.forEach(function (h) {
    if (!h.id) {
      var base = slugify(h.textContent), id = base, n = 2;
      while (usedIds[id]) { id = base + '-' + (n++); }
      h.id = id; usedIds[id] = true;
    }
    if (h.tagName === 'H2') { chapters.push(h); lastH2 = h; }
    chapterOf[h.id] = (lastH2 || h).textContent.trim();
  });

  /* ---------------- 2. Chapter menus ---------------- */
  var tocs = $$('[data-nugget-toc]', root);
  var chapterBar = $('[data-nugget-chapters]', root);
  var inlineToc = $('[data-nugget-toc-inline]', root);
  var asideToc = $('[data-nugget-toc-aside]', root);
  var links = [];

  if (chapters.length >= cfg.minHeadings) {
    var html = '';
    var num = 0;
    headings.forEach(function (h) {
      var isH2 = h.tagName === 'H2';
      if (isH2) num++;
      html += '<li class="nugget-toc__item' + (isH2 ? '' : ' nugget-toc__item--sub') + '">' +
        '<a href="#' + h.id + '" data-nugget-link="' + h.id + '">' +
        (isH2 ? '<span class="nugget-toc__num">' + num + '</span>' : '') +
        '<span class="nugget-toc__label">' + escapeHTML(h.textContent.trim()) + '</span></a></li>';
    });
    tocs.forEach(function (ol) { ol.innerHTML = html; });
    if (inlineToc) inlineToc.hidden = false;
    if (asideToc) asideToc.hidden = false;
    if (chapterBar) chapterBar.hidden = false;
    links = $$('[data-nugget-link]', root);
  } else {
    // Not enough chapters: drop the empty aside column so the body can use the width.
    var aside = $('[data-nugget-aside]', root);
    if (aside && !aside.querySelector('[data-nugget-embed]')) aside.hidden = true;
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------------- 3. Embedded blocks ---------------- */
  var store = $('[data-nugget-blocks]', root);
  var productBlock = store && cfg.showProduct ? store.querySelector('[data-nugget-embed="product"]') : null;
  var newsBlock = store && cfg.showNewsletter ? store.querySelector('[data-nugget-embed="newsletter"]') : null;

  // Author-placed shortcodes: a paragraph whose entire text is [[name]] (letters, digits, hyphens).
  // [[product]] and [[newsletter]] place those two blocks, once each. Any other name is swapped for
  // the block in the store marked data-nugget-embed="name" (e.g. [[dog-age-calculator]]). These extra
  // blocks are only ever placed by hand, never automatically. A shortcode with no block is removed.
  var shortcodeRE = /^\s*\[\[\s*([a-z0-9-]+)\s*\]\]\s*$/i;
  var placedProduct = false, placedNews = false;
  $$('p', body).forEach(function (p) {
    var m = shortcodeRE.exec(p.textContent || '');
    if (!m) return;
    var kind = m[1].toLowerCase();
    var block = null;
    if (kind === 'product') { if (!placedProduct) block = productBlock; }
    else if (kind === 'newsletter') { if (!placedNews) block = newsBlock; }
    else if (store) block = store.querySelector('[data-nugget-embed="' + kind + '"]');
    if (!block) { p.parentNode.removeChild(p); return; }
    p.parentNode.replaceChild(block, p);
    if (kind === 'product') placedProduct = true;
    else if (kind === 'newsletter') placedNews = true;
    // The calculator may already have mounted itself, or its script may load later. Both are fine.
    else if (block.hasAttribute('data-pn-dog-age') && window.PNDogAge) window.PNDogAge.mount(block);
  });

  function isEmbed(el) { return el && el.nodeType === 1 && el.hasAttribute('data-nugget-embed'); }
  function isHeading(el) { return el && /^H[23]$/.test(el.tagName); }

  // When the section also renders a product block after the body, nothing may be appended to the
  // end of the body: it would sit directly on top of that block.
  var allowEnd = !cfg.hasEndProduct;

  // A post whose body wraps its chapters in its own container (e.g. scoped styles around the whole
  // post) has headings that are not direct children of the body. Those slots are skipped: inserting
  // there used to throw and stop the rest of this script (progress bar, active chapter, anchors).
  // Insert before the (n+1)th chapter = "after chapter n". Returns the chapter index used,
  // -1 when appended at the end of the body, or null when no slot was free.
  function placeAfterChapter(block, n) {
    var idx = n; // chapters[n] is the heading that starts chapter n+1
    while (idx < chapters.length) {
      var target = chapters[idx];
      if (target.parentNode === body && !isEmbed(target.previousElementSibling)) { body.insertBefore(block, target); return idx; }
      idx++;
    }
    return allowEnd ? placeAtEnd(block) : null;
  }
  function placeAtEnd(block) {
    if (!isEmbed(body.lastElementChild)) { body.appendChild(block); return -1; }
    return null;
  }
  // Walk backwards from the last chapter and use the first free gap (never before chapter 1).
  function placeBeforeLastFreeChapter(block) {
    for (var idx = chapters.length - 1; idx >= 1; idx--) {
      var target = chapters[idx];
      if (target.parentNode === body && !isEmbed(target.previousElementSibling)) { body.insertBefore(block, target); return idx; }
    }
    return null;
  }
  // Fallback for posts with few or no chapters: insert before the top-level element at `frac`
  // of the way through the body, never splitting a heading from its first paragraph and never
  // next to another block. Returns -2 when placed, null otherwise.
  function placeAtFraction(block, frac) {
    var kids = $$(':scope > *', body).filter(function (el) { return !isEmbed(el); });
    if (kids.length < 3) return null;
    var i = Math.max(1, Math.min(kids.length - 1, Math.round(kids.length * frac)));
    for (var tries = 0; tries < kids.length; tries++) {
      var ref = kids[(i + tries) % kids.length];
      if (ref === kids[0]) continue;
      if (isHeading(ref.previousElementSibling) || isEmbed(ref.previousElementSibling) || isEmbed(ref)) continue;
      body.insertBefore(block, ref);
      return -2;
    }
    return null;
  }

  var productAt = null;
  if (productBlock && !placedProduct) {
    if (chapters.length === 0) productAt = allowEnd ? placeAtFraction(productBlock, 0.45) : null;
    if (productAt === null) productAt = placeAfterChapter(productBlock, cfg.productAfter);
    // No chapter slot and an end-of-post block exists: that block covers it — skip the inline one.
    placedProduct = productAt !== null;
  }
  if (newsBlock && !placedNews) {
    var target = cfg.newsletterAfter;
    // Short post: both blocks would stack at the end. Put the newsletter mid-way instead.
    if (target >= chapters.length && productAt === -1) target = Math.max(1, Math.floor(chapters.length / 2));
    if (target === cfg.productAfter && productAt !== null && productAt !== -2) target = target + 1;
    var newsAt = chapters.length ? placeAfterChapter(newsBlock, target) : (allowEnd ? placeAtEnd(newsBlock) : null);
    if (newsAt === null && chapters.length >= 2) newsAt = placeBeforeLastFreeChapter(newsBlock);
    if (newsAt === null) newsAt = placeAtFraction(newsBlock, 0.6);
    placedNews = newsAt !== null;
  }
  if (store) store.parentNode.removeChild(store);

  // Klaviyo: load onsite JS only when the block is on the page and nothing else loaded it.
  if (placedNews && cfg.klaviyoCompanyId && $('[data-nugget-klaviyo]', body) && !window.klaviyo && !$('script[src*="klaviyo.js"]')) {
    var ks = document.createElement('script');
    ks.async = true;
    ks.src = 'https://static.klaviyo.com/onsite/js/' + encodeURIComponent(cfg.klaviyoCompanyId) + '/klaviyo.js';
    document.head.appendChild(ks);
  }

  /* ---------------- 4. Sticky chapter bar (mobile/tablet) ---------------- */
  var barBtn = chapterBar ? chapterBar.querySelector('.nugget-chapters__btn') : null;
  var barList = chapterBar ? chapterBar.querySelector('.nugget-chapters__list') : null;
  var barCurrent = $('[data-nugget-current]', root);
  function setBarOpen(open) {
    if (!barBtn || !barList) return;
    barBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    barList.hidden = !open;
    chapterBar.classList.toggle('is-open', open);
  }
  if (barBtn) {
    barBtn.addEventListener('click', function () { setBarOpen(barList.hidden); });
    document.addEventListener('click', function (e) { if (chapterBar && !chapterBar.contains(e.target)) setBarOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setBarOpen(false); });
  }
  links.forEach(function (a) {
    a.addEventListener('click', function () { setBarOpen(false); });
  });

  /* ---------------- 5. Active chapter + progress ---------------- */
  var progressBar = $('[data-nugget-progress]');
  var activeId = null;
  function offsetTop(el) { var r = el.getBoundingClientRect(); return r.top + window.pageYOffset; }

  function update() {
    var scrollY = window.pageYOffset;
    var lineY = scrollY + headerHeight() + (chapterBar && !chapterBar.hidden ? 56 : 0) + 24;

    // Progress through the article body (0 at first sight of the body, 1 when its bottom scrolls past the fold).
    if (progressBar) {
      var top = offsetTop(body), height = body.offsetHeight, vh = window.innerHeight;
      var p = (scrollY + vh - top) / (height + vh * 0.25);
      p = Math.max(0, Math.min(1, p));
      progressBar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      progressBar.parentNode.classList.toggle('is-visible', scrollY > top - vh * 0.5);
    }

    if (!headings.length || !links.length) return;
    var current = null;
    for (var i = 0; i < headings.length; i++) {
      if (offsetTop(headings[i]) <= lineY) current = headings[i]; else break;
    }
    // Past the end of the body: keep the last chapter lit rather than none.
    var id = current ? current.id : null;
    if (id === activeId) return;
    activeId = id;
    links.forEach(function (a) {
      var on = a.getAttribute('data-nugget-link') === id;
      if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      a.parentNode.classList.toggle('is-active', on);
    });
    if (barCurrent) {
      // The bar shows the chapter (H2) even when an H3 is active.
      var label = current ? chapterOf[current.id] : null;
      barCurrent.textContent = label || barCurrent.getAttribute('data-default') || barCurrent.textContent;
    }
    // Keep the active item in view inside a tall aside menu.
    var activeLink = asideToc && asideToc.querySelector('[aria-current]');
    if (activeLink && asideToc.scrollHeight > asideToc.clientHeight) {
      var lr = activeLink.getBoundingClientRect(), tr = asideToc.getBoundingClientRect();
      if (lr.top < tr.top || lr.bottom > tr.bottom) activeLink.scrollIntoView({ block: 'nearest' });
    }
  }
  if (barCurrent) barCurrent.setAttribute('data-default', barCurrent.textContent);

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; update(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', update);
  update();

  // Offset anchor jumps for the sticky header + chapter bar (CSS scroll-margin-top does the work; this sets the value).
  function setScrollMargin() {
    var h = headerHeight();
    var m = h + (chapterBar && !chapterBar.hidden && window.innerWidth < 990 ? 56 : 0) + 16;
    root.style.setProperty('--nugget-header-h', h + 'px');
    root.style.setProperty('--nugget-scroll-margin', m + 'px');
  }
  setScrollMargin();
  window.addEventListener('resize', setScrollMargin);

  // Deep link: the browser may have jumped before ids existed. Re-scroll once ids are assigned.
  if (location.hash) {
    var target = null;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
    if (target && body.contains(target)) {
      window.requestAnimationFrame(function () { target.scrollIntoView(); });
    }
  }
  }

  init();
  // Theme editor re-renders the section without re-running scripts.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-nugget]')) init();
  });
})();

/* Shareable graphics (Oct 2026): a small Pinterest "Save" link and an "Embed" button under every
 * figure.pn-graphic (branded infographics, charts, comparison tables) in a post. The embed code
 * shows the graphic and a credit link back to the post. Separate from init() so it runs on every
 * article template. */
(function () {
  'use strict';
  var PIN = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path fill="#E60023" d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/></svg>';
  var CODE = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M8.5 7L3.5 12l5 5M15.5 7l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function initShare() {
    var figs = document.querySelectorAll('figure.pn-graphic');
    if (!figs.length) return;
    var canonEl = document.querySelector('link[rel="canonical"]');
    var page = (canonEl && canonEl.href) || location.href.split('#')[0].split('?')[0];
    Array.prototype.forEach.call(figs, function (fig, i) {
      if (fig.querySelector('.pn-share')) return;
      var img = fig.querySelector('img');
      if (!img) return;
      var src = img.src || img.getAttribute('src') || '';
      var alt = img.getAttribute('alt') || '';
      var cap = fig.querySelector('figcaption');
      var desc = (fig.getAttribute('data-pin-description') || alt) + ' | Pet Nugget';
      var pinUrl = 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(page) +
        '&media=' + encodeURIComponent(src) + '&description=' + encodeURIComponent(desc);
      var embed = '<a href="' + page + '"><img src="' + src + '" alt="' + esc(alt) + '" width="600" style="max-width:100%;height:auto"></a>\n' +
        '<p>Infographic by <a href="' + page + '">Pet Nugget</a></p>';
      var id = 'pn-embed-' + i;
      var wrap = document.createElement('div');
      wrap.className = 'pn-share';
      wrap.innerHTML =
        '<a class="pn-share__btn" href="' + esc(pinUrl) + '" target="_blank" rel="noopener" aria-label="Save this graphic to Pinterest">' + PIN + '<span>Save</span></a>' +
        '<button type="button" class="pn-share__btn" aria-expanded="false" aria-controls="' + id + '">' + CODE + '<span>Embed</span></button>' +
        '<div class="pn-share__panel" id="' + id + '" hidden>' +
          '<p>Free to share. Paste this code on your site and keep the credit link.</p>' +
          '<textarea readonly rows="3" aria-label="Embed code">' + esc(embed) + '</textarea>' +
          '<button type="button" class="pn-share__copy">Copy code</button>' +
        '</div>';
      if (cap) cap.insertAdjacentElement('afterend', wrap); else fig.appendChild(wrap);
      var toggle = wrap.querySelector('[aria-controls]');
      var panel = wrap.querySelector('.pn-share__panel');
      var ta = wrap.querySelector('textarea');
      toggle.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) ta.select();
      });
      wrap.querySelector('.pn-share__copy').addEventListener('click', function (e) {
        var b = e.currentTarget;
        function done() { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy code'; }, 1800); }
        ta.select();
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(ta.value).then(done, function () { document.execCommand('copy'); done(); });
        else { document.execCommand('copy'); done(); }
      });
    });
  }
  /* Tables (Nov 3, 2026): wrap each in-body table so it can scroll sideways on phones (styles in nugget.css). */
  function initTables() {
    var body = document.querySelector('[data-nugget-body]') || document.querySelector('.nugget__body');
    if (!body) return;
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (t) {
      if (t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('pn-table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'pn-table-wrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
      var heads = Array.prototype.map.call(t.querySelectorAll('thead th'), function (th) { return (th.textContent || '').trim(); });
      if (heads.length && heads.length <= 4) {
        t.classList.add('pn-table--stack');
        Array.prototype.forEach.call(t.querySelectorAll('tbody tr'), function (tr) {
          Array.prototype.forEach.call(tr.children, function (cell, i) {
            if (cell.tagName === 'TD' && heads[i] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', heads[i]);
          });
        });
      }
    });
  }
  function initExtras() { initShare(); initTables(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initExtras); else initExtras();
})();
